module.exports = __webpack_public_path__ + "is.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/css/fonts/flag-icon-css/flags/4x3/is.svg
// module id = 874
// module chunks = 0